import { render } from "./PostFooter.vue?vue&type=template&id=6f3cb37b"
import script from "./PostFooter.vue?vue&type=script&lang=js"
export * from "./PostFooter.vue?vue&type=script&lang=js"

import "./PostFooter.vue?vue&type=style&index=0&id=6f3cb37b&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__